<template>
  <div class="flex items-center px-16 h-48">
    <RevButtonIcon
      v-if="back"
      :alternative-text="i18n(translations.back)"
      :icon="IconChevronLeft"
      :to="back"
      variant="ghost"
    />
    <div v-else class="w-48" />

    <p class="heading-3 flex-1 text-center">
      {{ title }}
    </p>

    <RevButtonIcon
      :alternative-text="i18n(translations.cartButton)"
      :icon="IconShoppingBag"
      :to="resolveLocalizedRoute({ name: CHECKOUT.CART })"
      variant="ghost"
    />
  </div>
</template>

<script setup lang="ts">
import type { RouteLocationRaw } from 'vue-router'

import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevButtonIcon } from '@ds/components/ButtonIcon'
import { IconChevronLeft } from '@ds/icons/IconChevronLeft'
import { IconShoppingBag } from '@ds/icons/IconShoppingBag'

import { useRouteLocationWithLocale } from '~/composables/useRouteLocationWithLocale'
import { CHECKOUT } from '~/scopes/checkout/routes-names'

import translations from './OutletTopBar.translations'

defineProps<{
  title: string
  back?: RouteLocationRaw
}>()

const i18n = useI18n()
const resolveLocalizedRoute = useRouteLocationWithLocale()
</script>
